// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"9f13323b","297":"df19b13d","643":"1a2239d6","787":"3668cbb9"}[chunkId] + ".chunk.js";
};